export default "__VITE_ASSET__CcVdKdKO__"